import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AxelButton } from '@pdm/axel-ui-components';
import { useAuth } from '../contexts/AuthContext';

/**
 * Wrapper component for AxelButton that uses hooks for auth and routing.
 * Shows a floating action button (FAB) on all pages except Axel routes.
 */
const AxelButtonWrapper: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { canAccessAxel, isAuthenticated } = useAuth();

  // Don't show button on Axel routes or if not authenticated
  const isAxelRoute = location.pathname.startsWith('/axel');
  if (!isAuthenticated || !canAccessAxel || isAxelRoute) {
    return null;
  }

  return (
    <AxelButton onClick={() => navigate('/axel')} pulse size="large" tooltip="Chat with Axel" />
  );
};

export default AxelButtonWrapper;
